import React from 'react';

import { SIZE, ALIGN } from 'form/constants/label_component_enuns.js';

export default class LabelComponent extends React.Component {

	getLabelContainerId() {
		return "label__" + this.props.id;
	}

	cssLabel() {
		var align = ALIGN[this.props.align];
		var size = SIZE[this.props.size];
		return `label-text ${align} ${size}`;
	}

	styleLabel() {
		return {
			"color": `#${this.props.color}`,
			"backgroundColor": `#${this.props.backgroundColor}`
		};
	}

	render() {
		const hide = !this.props.visible ? 'hide' : '';
		return (
			<div className={`form__label label-field col s12 offset-s0 roffset-s0 ${hide}`} id={this.getLabelContainerId()} style={this.styleLabel()} aria-label={this.props.label} tabIndex='0'>
				{this.props.size.toLowerCase() === "large" &&  <h1 className={this.cssLabel()} style={{margin: 0, lineHeight: 1.5, fontWeight: 'normal'}}>{this.props.label}</h1>}
				{this.props.size.toLowerCase() === "medium" && <h2 className={this.cssLabel()} style={{margin: 0, lineHeight: 1.5, fontWeight: 'normal'}}>{this.props.label}</h2>}
				{this.props.size.toLowerCase() === "small" &&  <h3 className={this.cssLabel()} style={{margin: 0, lineHeight: 1.5, fontWeight: 'normal'}}>{this.props.label}</h3>}
			</div>
		);
	}
}
